import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'

class DownloadLinks extends React.Component {
  downloadNotification() {
    ButterToast.raise({
      content: (
        <Cinnamon.Crunch
          title="Downloading Roster"
          content="Your download should start momentarily."
          scheme={Cinnamon.Crisp.SCHEME_GREY}
        />
      ),
    })
  }

  render() {
    return (
      <div>
        <h4>Download</h4>
        <a
          href={`/instructor/people.download_roster/${this.props.coursenum}/xlsx/`}
        >
          <Button bsStyle="link" onClick={this.downloadNotification}>
            <i className="fal fa-fw fa-file-excel" /> Download Student Roster
            (.xlsx)
          </Button>
        </a>
        <a
          href={`/instructor/people.download_roster/${this.props.coursenum}/csv/`}
        >
          <Button bsStyle="link" onClick={this.downloadNotification}>
            <i className="fal fa-fw fa-file-csv" /> Download Student Roster
            (.csv)
          </Button>
        </a>
      </div>
    )
  }
}

DownloadLinks.propTypes = {
  coursenum: PropTypes.string,
}

const mapStateToProps = state => {
  return {
    coursenum: state.coursenum,
  }
}

export default connect(mapStateToProps)(DownloadLinks)
